import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../../../../external-components/angular-material.module';
import { SharedModule } from '../../../shared/shared.module';
import { PipesModule } from '../../../../pipes/pipes.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { RouterModule } from '@angular/router';
import { ProcedureListComponent } from './procedure-list.component';
import { ProcedureListFilterComponent } from './procedure-list-filter.component';


@NgModule({
  declarations: [ProcedureListComponent, ProcedureListFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    /* Custom modules */
    AngularMaterialModule,
    SharedModule,
    PipesModule,

    /* Otros */
    FlexLayoutModule,
    RouterModule
  ]
})
export class ProcedureListModule { }
